export default __webpack_public_path__ + "static/apple-de-01eb8c859b4ffd1689de56d23808ad54.png";